// src/pages/ReportIssue/components/PersonalDetailsSection.js
import React from "react";
import {
    TextField,
    Typography,
    Box,
    Grid,
} from "@mui/material";
import { ErrorMessage, Field } from "formik";
import { Person as PersonIcon } from "@mui/icons-material";

const PersonalDetailsSection = ({ formikProps }) => {
    // Add a safety check to prevent accessing properties of undefined
    if (!formikProps) {
        console.warn("formikProps is undefined in PersonalDetailsSection");
        return null;
    }

    // Make sure errors and touched objects exist
    const errors = formikProps.errors || {};
    const touched = formikProps.touched || {};

    return (
        <Box mb={4}>
            <Box
                display="flex"
                alignItems="center"
                gap={1}
                mb={2}
            >
                <PersonIcon sx={{ color: '#3B82F6' }} />
                <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: '#3A5A78' }}
                >
                    Personal Details
                </Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <Field
                        as={TextField}
                        name="first_name"
                        label="First Name"
                        variant="outlined"
                        disabled={true}
                        error={
                            errors.first_name &&
                            touched.first_name
                        }
                        helperText={
                            <ErrorMessage name="first_name" />
                        }
                        required
                        fullWidth
                        InputProps={{
                            sx: { borderRadius: '10px' }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Field
                        as={TextField}
                        name="last_name"
                        label="Last Name"
                        disabled={true}
                        error={
                            errors.last_name &&
                            touched.last_name
                        }
                        helperText={
                            <ErrorMessage name="last_name" />
                        }
                        required
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            sx: { borderRadius: '10px' }
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                        as={TextField}
                        name="phone_number"
                        label="Phone Number"
                        error={
                            errors.phone_number &&
                            touched.phone_number
                        }
                        helperText={
                            <ErrorMessage name="phone_number" />
                        }
                        required
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            sx: { borderRadius: '10px' }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        as={TextField}
                        name="national_id"
                        label="National ID"
                        type="number"
                        disabled={true}
                        required
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            sx: { borderRadius: '10px' }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Field
                        as={TextField}
                        name="property_name"
                        label="Property"
                        error={
                            errors.property_name &&
                            touched.property_name
                        }
                        helperText={
                            <ErrorMessage name="property_name" />
                        }
                        required
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        InputProps={{
                            sx: { borderRadius: '10px' }
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

// Add a defaultProps to ensure formikProps is always defined
PersonalDetailsSection.defaultProps = {
    formikProps: {
        errors: {},
        touched: {}
    }
};

export default PersonalDetailsSection;